<p-dialog
  [header]="getDialogHeader() | translate"
  dismissableMask
  modal
  class="fileupload"
  [(visible)]="visible"
  [style]="{ width: '500px' }"
  [breakpoints]="{ '960px': '95vw' }"
>
  <p-fileupload
    #fileUpload
    accept=".jpg,.jpeg,.png,.svg"
    maxFileSize="20000000"
    invalidFileSizeMessageSummary="{{
      'fileupload.invalidFileSizeMessageSummary' | translate
    }}"
    invalidFileSizeMessageDetail="{{
      'fileupload.invalidFileSizeMessageDetail' | translate
    }}"
    invalidFileTypeMessageSummary="{{
      'fileupload.invalidFileTypeMessageSummary' | translate
    }}"
    invalidFileTypeMessageDetail="{{
      'fileupload.invalidFileTypeMessageDetail' | translate
    }}"
    invalidFileLimitMessageSummary="{{
      'fileupload.invalidFileLimitMessageSummary' | translate
    }}"
    invalidFileLimitMessageDetail="{{
      'fileupload.invalidFileLimitMessageDetail' | translate
    }}"
  >
    <ng-template #content let-files>
      @if (loading()) {
        <div class="fileupload-content">
          <div class="upload-box upload-box-loading">
            <p-progressbar
              id="loadingProgressBar"
              mode="indeterminate"
              [style]="{ height: '6px' }"
            />
          </div>
        </div>
      } @else if (files?.length > 0 || existingFile()) {
        <div class="fileupload-content">
          <div class="upload-box">
            <p-button
              [style]="{ 'padding-right': '32px', 'padding-left': '32px' }"
              [label]="'buttons.replace' | translate"
              icon="pi pi-upload"
              severity="secondary"
              (click)="fileUpload.choose()"
            ></p-button>
            <div class="flex flex-wrap gap-4">
              @for (file of files; track file; let idx = $index) {
                <app-logo-file-item
                  [file]="file"
                  [index]="idx"
                  (remove)="fileUpload.remove($event[0], $event[1])"
                ></app-logo-file-item>
              }
              @if (existingFile() && files?.length === 0) {
                <app-logo-file-item
                  [file]="existingFile()"
                  [index]="0"
                  [showRemove]="false"
                ></app-logo-file-item>
              }
            </div>
            @if (uploadError()) {
              <p class="fileupload-error w-full p-4">
                {{ uploadError() ?? "" | translate }}
              </p>
            }
          </div>
        </div>
      }
    </ng-template>
    <ng-template #file></ng-template>
    <ng-template #empty>
      @if (!existingFile()) {
        <div class="fileupload-content fileupload-content-empty">
          <div class="upload-box">
            <div class="flex flex-col items-center justify-center py-8">
              <p-button
                [label]="'buttons.upload' | translate"
                icon="pi pi-upload"
                severity="primary"
                (click)="fileUpload.choose()"
              ></p-button>
              <div class="upload-info mt-6 text-center">
                <p class="mb-2">
                  {{ "fileupload.dropFilesHere" | translate }}
                </p>
                <p class="text-muted-color text-sm">
                  {{
                    "fileupload.fileFormats"
                      | translate: { formats: "jpg, jpeg, png, svg" }
                  }}
                  <br />
                  {{ "fileupload.maxFileSize" | translate: { size: "20" } }}
                </p>
              </div>
            </div>
          </div>
        </div>
      }
    </ng-template>
  </p-fileupload>
  <ng-template #footer>
    <div class="flex justify-between gap-4 pt-4 w-full">
      <p-button
        type="button"
        class="cancel-btn w-full"
        severity="secondary"
        fluid
        (click)="visible = false"
        [label]="'buttons.cancel' | translate"
      ></p-button>
      <p-button
        type="button"
        class="save-btn w-full"
        fluid
        (click)="saveLogo()"
        [label]="'buttons.save' | translate"
        [disabled]="fileUpload.files.length === 0 || loading()"
      ></p-button>
    </div>
  </ng-template>
</p-dialog>
